import CryptoJS from 'crypto-js'

const SECRET_KEY = 'ALO_KRONOS_SECRET_2026'

export function validateLicenceInfo(licenceInfo) {
	if (!licenceInfo) return false

	const payload =
		`${licenceInfo.customer}|${licenceInfo.expiry}`

	const expectedSignature = CryptoJS.HmacSHA256(
		payload,
		SECRET_KEY,
	).toString()

	return expectedSignature === licenceInfo.signature
}

export function isLicenceExpired(licenceInfo) {
	if (!licenceInfo || !licenceInfo.expiry) return true

	const today = new Date()
	const expiry = new Date(licenceInfo.expiry)

	return today > expiry
}